import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Newsletter from "../contact/Newsletter";
import AboutCrousel from "./AboutCrousel";
import { Sun, Star, Briefcase, ShoppingBag, Banknote, MessageSquare } from "lucide-react";
import FAQSchema from "../../FAQSchema";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

function AboutPage() {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "  What is TheFinMaster.com?",
      answer:
        "TheFinMaster.com is your one-stop shop for all things personal finance! We provide clear and unbiased information on a wide range of financial products and services, like credit cards, mutual funds, and insurance. Think of us as your friendly neighborhood financial guide, helping you navigate the complexities of the financial world and make informed decisions.  ",
    },
    {
      question:
        " Can I compare financial products side-by-side on TheFinMaster.com?",
      answer:
        "Absolutely! We understand the importance of comparing different options before making a financial decision. TheFinMaster.com offers user-friendly comparison tools for credit cards, mutual funds, and insurance policies.  These tools allow you to analyze key features, fees, and benefits to choose the product that best aligns with your needs.",
    },
    {
      question: "   Does TheFinMaster.com offer any educational resources?",
      answer:
        " TheFinMaster.com offers a comprehensive library of educational resources, including informative blog posts. Our engaging blog articles cover a wide range of financial topics, from the basics of budgeting and saving to more complex concepts like investing and retirement planning.",
    },
    {
      question:
        "Is TheFinMaster.com affiliated with any financial institutions?",
      answer:
        " TheFinMaster.com maintains a strict policy of editorial independence. We are not affiliated with any banks, investment companies, or insurance providers. This ensures that the information and recommendations we provide are objective and unbiased.  Our goal is to empower you with the knowledge to make informed financial decisions, not to promote specific products or services.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  const backgroundImageUrl = "../assets/bgabout.webp";
  const data = [
    {
      iconbutton:
        "https://www.iconpacks.net/icons/1/free-red-card-icon-460-thumb.png",
      price: "$19.99",
      ownedfrom: "Owned from January 2022",
    },
    {
      iconbutton:
        "https://www.iconpacks.net/icons/1/free-red-card-icon-460-thumb.png",
      price: "$19.99",
      ownedfrom: "Owned from January 2022",
    },
    {
      iconbutton:
        "https://www.iconpacks.net/icons/1/free-red-card-icon-460-thumb.png",
      price: "$19.99",
      ownedfrom: "Owned from January 2022",
    },
    {
      iconbutton:
        "https://www.iconpacks.net/icons/1/free-red-card-icon-460-thumb.png",
      price: "$19.99",
      ownedfrom: "Owned from January 2022",
    },
    // Add more objects as needed
  ];
  return (
    <>
      <Helmet>
        <title>Thefinmaster About </title>
        <link rel="canonical" href="https://thefinmaster.com/about" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <div className="flex w-full flex-col gap-[100px] bg-white-A700 md:gap-[75px] sm:gap-[50px]">
        <div className="flex flex-col items-center gap-[100px] md:gap-[75px] sm:gap-[50px]">
          <div className="container-xs flex flex-col gap-[38px] md:p-5">
            <div className="flex flex-col gap-4">
              <h1 className="text-center text-4xl md:text-7xl leading-[140%] tracking-[-1.08px]">
                <>
                  Reimagining real  to <br />
                  make it easier to unlock.
                </>
              </h1>
              <p className="text-center text-lg leading-[180%]">
                <>
                  On the other hand, we denounce with righteous indignation and dislike men who <br />
                  are so beguiled and demoralized by the charms of pleasure of the moment, <br />
                  so blinded by desire, that they cannot foresee the pain and trouble.
                </>
              </p>
            </div>
            <div className="flex flex-col gap-6 md:flex-row">
              <img src="https://cdn3d.iconscout.com/3d/premium/thumb/people-discussion-about-business-8659916-6909666.png"
                alt="image"
                className="h-[300px] md:h-[400px] w-full md:w-[50%] rounded-[10px] object-cover"
              />
              <img
                src="https://img.freepik.com/free-psd/icon-characters-representing-community-3d-illustration_1419-2990.jpg?size=338&ext=jpg&ga=GA1.1.553209589.1713657600&semt=ais"
                alt="image"
                className="h-[300px] md:h-[400px] w-full md:w-[50%] rounded-[10px] object-cover"
              />
            </div>
            <div className="flex flex-col gap-6 md:flex-row">
              <img
                src="https://img.freepik.com/free-photo/3d-rendering-people-avatars-zoom-call_23-2149576734.jpg"
                alt="image"
                className="h-[300px] md:h-[400px] w-full md:w-[50%] rounded-[10px] object-cover"
              />
              <img
                src="https://pingbix.com/wp-content/uploads/2024/04/4568171.webp"
                alt="image"
                className="h-[300px] md:h-[400px] w-full md:w-[50%] rounded-[10px] object-cover"
              />
            </div>
          </div>
        </div>
      </div> */}

      <div className="mx-auto max-w-screen-xl mt-4 mb-4">
        <div className="relative bg-cover bg-center h-80 md:h-96 flex items-center overflow-hidden">
          <div className="absolute inset-0 bg-black opacity-20"></div>
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-white text-center">
            <h1 className="text-3xl md:text-4xl lg:text-7xl font-bold mb-4">
              Welcome to TheFinMaster !
            </h1>
            <p className="text-sm md:text-base lg:text-lg mb-6">
              Empowering you to make informed financial decisions.
            </p>
          </div>
          <img
            className="absolute inset-0 object-cover w-full h-full"
            src={backgroundImageUrl}
            alt="Background"
          />
        </div>
      </div>

      {/* <div className="flex justify-center items-center px-4 ">
  <div className="text-center max-w-2xl mt-10">
    <h2 className="text-3xl font-semibold text-gray-900 mb-4">About FinMaster</h2>
    <p className="text-gray-700 leading-relaxed text-lg">
      At FinMaster, we are your trusted partner in financial empowerment.
      Navigating the world of personal finance can be complex, but with the right
      knowledge and tools, you can take control of your financial future. Our
      mission is to bridge the gap between financial literacy and actionable
      decision-making, helping individuals make smart, well-informed choices.
    </p>
    <p className="text-gray-700 leading-relaxed text-lg mt-4">
      We offer a comprehensive financial hub, covering everything from insurance
      and credit cards to Demat accounts and loans. Our expert-driven insights,
      comparison tools, and educational resources ensure you have all the
      information you need to choose the right financial products with confidence.
    </p>
    <p className="text-gray-700 leading-relaxed text-lg mt-4">
      At <strong>TheFinMaster.com</strong>, we believe that everyone deserves financial
      freedom, and our goal is to make finance simpler, more accessible, and
      empowering for all.
    </p>
    <p className="text-gray-700 leading-relaxed text-lg mt-4">
      Your journey to financial mastery starts here.
    </p>
  </div>
</div> */}
      <div className="lg:px-6 md:px-6 sm:px-0 px-0">
        <div className="shadow-lg rounded-md p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-8 text-gray-600 flex flex-col justify-center items-center text-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4 text-black">
            About FinMaster
          </h2>
          <p className="text-lg md:text-base lg:text-lg">
            At FinMaster, we are your trusted partner in financial empowerment.
            Navigating the world of personal finance can be complex, but with
            the right knowledge and tools, you can take control of your
            financial future. Our mission is to bridge the gap between financial
            literacy and actionable decision-making, helping individuals make
            smart, well-informed choices.
          </p>
          <p className="text-lg md:text-base lg:text-lg mt-2">
            We offer a comprehensive financial hub, covering everything from
            insurance and credit cards to Demat accounts and loans. Our
            expert-driven insights, comparison tools, and educational resources
            ensure you have all the information you need to choose the right
            financial products with confidence. TheFinMaster.com, we believe
            that everyone deserves financial freedom, and our goal is to make
            finance simpler, more accessible, and empowering for all.{" "}
          </p>
        </div>
      </div>
      {/* <div className="lg:px-14 md:lg:px-14 sm:py-0 mt-6">
      <div className="max-w-screen-[1440px] mx-auto mb-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 p-2">
          <div className="p-4 bg-white shadow border rounded-[10px]">
            <button className="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
              <Sun size={24} strokeWidth={1.5} />
            </button>
            <p className="text-2xl text-black my-5">Expert Financial Insights</p>
            <p className="text-base text-gray-700">
              Get well-researched, expert-driven articles and guides to help you understand personal finance better and make smarter financial decisions.
            </p>
          </div>

          <div className="p-4 bg-white shadow border rounded-[10px]">
            <button className="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
              <Star size={24} strokeWidth={1.5} />
            </button>
            <p className="text-2xl text-black my-5">Compare & Choose Wisely</p>
            <p className="text-base text-gray-700">
              Easily compare insurance plans, credit cards, loans, and investment options to find the best financial products suited to your needs.
            </p>
          </div>

          <div className="p-4 bg-white shadow border rounded-[10px]">
            <button className="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
              <Briefcase size={24} strokeWidth={1.5} />
            </button>
            <p className="text-2xl text-black my-5">Smart Financial Tools</p>
            <p className="text-base text-gray-700">
              Access user-friendly financial calculators, budget planners, and investment trackers to manage your money efficiently.
            </p>
          </div>

          <div className="p-4 bg-white shadow border rounded-[10px] lg:row-span-2">
            <button className="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
              <ShoppingBag size={24} strokeWidth={1.5} />
            </button>
            <p className="text-2xl text-black my-5">Simplified Financial Literacy</p>
            <p className="text-base text-gray-700">
              We break down complex financial jargon into easy-to-understand content, ensuring financial education is accessible to everyone.
            </p>
            <img className="hidden lg:block mt-5 rounded-[10px]" src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt="Pictures" />
          </div>

          <div className="p-4 bg-white shadow border rounded-[10px] lg:col-span-2 flex justify-between gap-5">
            <div>
              <button className="p-3 py-4 bg-[#F5F8FF] rounded-[10px] cursor-default">
                <Banknote size={24} strokeWidth={1.5} />
              </button>
              <p className="text-2xl text-black my-5">Trusted Partner Network</p>
              <p className="text-base text-gray-700">
                Explore financial products from reputable banks, NBFCs, and financial institutions, ensuring secure and reliable options.
              </p>
            </div>
            <div>
              <img className="hidden lg:block mt-5 rounded-[10px]" src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=400" alt="Pictures" />
            </div>
          </div>

          <div className="p-4 bg-white shadow border rounded-[10px]">
            <button className="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
              <MessageSquare size={24} strokeWidth={1.5} />
            </button>
            <p className="text-2xl text-black my-5">Financial Consultation</p>
            <p className="text-base text-gray-700">
              Connect with financial advisors and experts to receive personalized financial guidance tailored to your needs.
            </p>
          </div>
        </div>
      </div>
    </div> */}
    <div className="lg:px-14 md:lg:px-14 sm:py-0 mt-6">
  <div className="max-w-screen-[1440px] mx-auto mb-20">
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 p-2">
      
      <div className="p-4 bg-white shadow border rounded-[10px] transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
        <button className="p-2 bg-[#F5F8FF] rounded-[10px] transition-all duration-300 hover:bg-[#E0E7FF]">
          <Sun size={24} strokeWidth={1.5} className="transition-all duration-300 hover:text-blue-500" />
        </button>
        <p className="text-2xl text-black my-5">Expert Financial Insights</p>
        <p className="text-base text-gray-700">
          Get well-researched, expert-driven articles and guides to help you understand personal finance better and make smarter financial decisions.
        </p>
      </div>

      <div className="p-4 bg-white shadow border rounded-[10px] transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
        <button className="p-2 bg-[#F5F8FF] rounded-[10px] transition-all duration-300 hover:bg-[#E0E7FF]">
          <Star size={24} strokeWidth={1.5} className="transition-all duration-300 hover:text-yellow-500" />
        </button>
        <p className="text-2xl text-black my-5">Compare & Choose Wisely</p>
        <p className="text-base text-gray-700">
          Easily compare insurance plans, credit cards, loans, and investment options to find the best financial products suited to your needs.
        </p>
      </div>

      <div className="p-4 bg-white shadow border rounded-[10px] transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
        <button className="p-2 bg-[#F5F8FF] rounded-[10px] transition-all duration-300 hover:bg-[#E0E7FF]">
          <Briefcase size={24} strokeWidth={1.5} className="transition-all duration-300 hover:text-green-500" />
        </button>
        <p className="text-2xl text-black my-5">Smart Financial Tools</p>
        <p className="text-base text-gray-700">
          Access user-friendly financial calculators, budget planners, and investment trackers to manage your money efficiently.
        </p>
      </div>

      <div className="p-4 bg-white shadow border rounded-[10px] lg:row-span-2 transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
        <button className="p-2 bg-[#F5F8FF] rounded-[10px] transition-all duration-300 hover:bg-[#E0E7FF]">
          <ShoppingBag size={24} strokeWidth={1.5} className="transition-all duration-300 hover:text-red-500" />
        </button>
        <p className="text-2xl text-black my-5">Simplified Financial Literacy</p>
        <p className="text-base text-gray-700">
          We break down complex financial jargon into easy-to-understand content, ensuring financial education is accessible to everyone.
        </p>
        <img className="hidden lg:block mt-5 rounded-[10px]" src="/assets/about122.png" alt="Pictures" />
      </div>

      <div className="p-4 bg-white shadow border rounded-[10px] lg:col-span-2 flex justify-between gap-5 transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
        <div>
          <button className="p-3 py-4 bg-[#F5F8FF] rounded-[10px] transition-all duration-300 hover:bg-[#E0E7FF]">
            <Banknote size={24} strokeWidth={1.5} className="transition-all duration-300 hover:text-purple-500" />
          </button>
          <p className="text-2xl text-black my-5">Trusted Partner Network</p>
          <p className="text-base text-gray-700">
            Explore financial products from reputable banks, NBFCs, and financial institutions, ensuring secure and reliable options.
          </p>
        </div>
        <div>
          <img className="hidden lg:block mt-5 rounded-[10px]" src="/assets/about121.png" alt="Pictures" />
        </div>
      </div>

      <div className="p-4 bg-white shadow border rounded-[10px] transition-all duration-300 hover:shadow-lg hover:scale-[1.02]">
        <button className="p-2 bg-[#F5F8FF] rounded-[10px] transition-all duration-300 hover:bg-[#E0E7FF]">
          <MessageSquare size={24} strokeWidth={1.5} className="transition-all duration-300 hover:text-teal-500" />
        </button>
        <p className="text-2xl text-black my-5">Financial Consultation</p>
        <p className="text-base text-gray-700">
          Connect with financial advisors and experts to receive personalized financial guidance tailored to your needs.
        </p>
      </div>

    </div>
  </div>
</div>

      {/* <div className=" lg:px-14 md:lg:px-14 sm:py-0  mt-6">
        <div class="max-w-screen-[1440px] mx-auto mb-20">
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-5 p-2">
            <div class="p-4 bg-white shadow border rounded-[10px]">
              <button class="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4V5M12 19V20M5.07178 8L5.9378 8.5M18.0622 15.5L18.9282 16M18.9282 7.99999L18.0622 8.49999M5.93781 15.5L5.07178 16M16 12C16 9.79086 14.2091 8 12 8C9.79084 8 7.99998 9.79086 7.99998 12C7.99998 14.2091 9.79084 16 12 16C14.2091 16 16 14.2091 16 12Z"
                    stroke="#252432"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <p class=" text-2xl text-black my-5">Expert Financial Insights</p>

              <p class=" text-base text-gray-700">
                Get well-researched, expert-driven articles and guides to help
                you understand personal finance better and make smarter
                financial decisions.
              </p>
            </div>

            <div class="p-4 bg-white shadow border rounded-[10px]">
              <button class="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2442 4.86956C11.0022 3.47968 12.9979 3.47968 13.7559 4.86956L14.9723 7.09993C15.2599 7.62738 15.7694 7.99758 16.36 8.10817L18.8571 8.57579C20.4132 8.86719 21.0299 10.7653 19.9422 11.9157L18.1969 13.7617C17.7842 14.1983 17.5895 14.7973 17.6668 15.3931L17.9938 17.9125C18.1975 19.4824 16.5829 20.6555 15.1527 19.9766L12.8577 18.8871C12.3149 18.6295 11.6851 18.6295 11.1424 18.8871L8.84732 19.9766C7.41713 20.6555 5.80257 19.4824 6.00629 17.9125L6.3332 15.3931C6.41051 14.7973 6.21588 14.1983 5.80313 13.7617L4.05781 11.9157C2.97019 10.7653 3.58689 8.86719 5.14299 8.57579L7.64007 8.10817C8.2306 7.99758 8.74014 7.62738 9.02779 7.09993L10.2442 4.86956Z"
                    stroke="#252432"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <p class=" text-2xl text-black my-5">Compare & Choose Wisely</p>

              <p class="text-base text-gray-700">
                Easily compare insurance plans, credit cards, loans, and
                investment options to find the best financial products suited to
                your needs.
              </p>
            </div>

            <div class="p-4 bg-white shadow border rounded-[10px]">
              <button class="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 18H6C4.34315 18 3 16.6569 3 15V6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V15C21 16.6569 19.6569 18 18 18H14M10 18V21M10 18H14M14 18V21M10 21H14M10 21H9M14 21H15"
                    stroke="#252432"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <p class=" text-2xl text-black my-5">Smart Financial Tools</p>

              <p class="text-base text-gray-700">
                Access user-friendly financial calculators, budget planners, and
                investment trackers to manage your money efficiently.
              </p>
            </div>

            <div class="p-4 bg-white shadow border rounded-[10px] lg:row-span-2">
              <button class="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.01005 11.75C9.42426 11.75 9.76005 11.4142 9.76005 11C9.76005 10.5858 9.42426 10.25 9.01005 10.25V11.75ZM9.00005 10.25C8.58583 10.25 8.25005 10.5858 8.25005 11C8.25005 11.4142 8.58583 11.75 9.00005 11.75V10.25ZM15.01 11.75C15.4243 11.75 15.76 11.4142 15.76 11C15.76 10.5858 15.4243 10.25 15.01 10.25V11.75ZM15 10.25C14.5858 10.25 14.25 10.5858 14.25 11C14.25 11.4142 14.5858 11.75 15 11.75V10.25ZM6.77814 8.75H17.222V7.25H6.77814V8.75ZM19.4653 10.8274L20.0038 17.8274L21.4994 17.7124L20.9609 10.7124L19.4653 10.8274ZM17.7604 20.25H6.23968V21.75H17.7604V20.25ZM3.99631 17.8274L4.53477 10.8274L3.03919 10.7124L2.50073 17.7124L3.99631 17.8274ZM6.23968 20.25C4.92903 20.25 3.89579 19.1342 3.99631 17.8274L2.50073 17.7124C2.33319 19.8904 4.05527 21.75 6.23968 21.75V20.25ZM20.0038 17.8274C20.1043 19.1342 19.0711 20.25 17.7604 20.25V21.75C19.9448 21.75 21.6669 19.8904 21.4994 17.7124L20.0038 17.8274ZM17.222 8.75C18.3977 8.75 19.3752 9.65519 19.4653 10.8274L20.9609 10.7124C20.8106 8.75865 19.1815 7.25 17.222 7.25V8.75ZM6.77814 7.25C4.81863 7.25 3.18947 8.75865 3.03919 10.7124L4.53477 10.8274C4.62494 9.65519 5.60244 8.75 6.77814 8.75V7.25ZM14.25 6V8H15.75V6H14.25ZM9.75005 8V6H8.25005V8H9.75005ZM12 3.75C13.2427 3.75 14.25 4.75736 14.25 6H15.75C15.75 3.92893 14.0711 2.25 12 2.25V3.75ZM12 2.25C9.92898 2.25 8.25005 3.92893 8.25005 6H9.75005C9.75005 4.75736 10.7574 3.75 12 3.75V2.25ZM9.01005 10.25H9.00005V11.75H9.01005V10.25ZM15.01 10.25H15V11.75H15.01V10.25Z"
                    fill="#252432"
                  />
                </svg>
              </button>

              <p class="text-2xl text-black my-5">
                Simplified Financial Literacy
              </p>

              <p class=" text-base text-gray-700">
                We break down complex financial jargon into easy-to-understand
                content, ensuring financial education is accessible to everyone.
              </p>

              <img
                class="hidden lg:block mt-5 rounded-[10px]"
                src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=1&amp;w=500"
                alt="Pictures"
              />
            </div>

            <div class="p-4 bg-white shadow border rounded-[10px] lg:col-span-2 flex justify-between gap-5">
              <div>
                <button class="p-3 py-4 bg-[#F5F8FF] rounded-[10px] cursor-default">
                  <svg
                    width="21"
                    height="13"
                    viewBox="0 0 21 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21 0L14.3528 12.8765H8.05945L10.8101 7.61233H10.6832C8.37078 10.5927 4.91823 12.5553 0 13V7.6855C0 7.6855 3.1455 7.50067 4.99585 5.57067H0.0023098V0H5.71431L5.61596 4.58333H5.74275L8.03687 0H12.5781L12.2834 4.555H12.4103L14.7885 0H21Z"
                      fill="#5B54FF"
                    />
                  </svg>
                </button>

                <p class=" text-2xl text-black my-5">Trusted Partner Network</p>

                <p class=" text-base text-gray-700">
                  Explore financial products from reputable banks, NBFCs, and
                  financial institutions, ensuring secure and reliable options.
                </p>
              </div>
              <div>
                <img
                  class="hidden lg:block mt-5 rounded-[10px]"
                  src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=1&amp;w=400"
                  alt="Pictures"
                />
              </div>
            </div>

            <div class="p-4 bg-white shadow border rounded-[10px]">
              <button class="p-2 bg-[#F5F8FF] rounded-[10px] cursor-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 9L9.53354 10.5201C10.7287 11.2372 10.8423 12.9262 9.75394 13.7968L7 16M12 16H17M6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21Z"
                    stroke="#252432"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <p class=" text-2xl text-black my-5">
                Real-Time Updates & Trends
              </p>

              <p class=" text-base text-gray-700">
                Stay ahead with the latest financial trends, market updates, and
                policy changes that impact your financial decisions.
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="w-full flex flex-col items-center ">
        <div className="w-[90%] flex flex-wrap md:flex-nowrap justify-between mt-8">
          <div className="w-full">
            <img src="../assets/misson121.png" alt="img1" />
          </div>
          <div className="w-full flex items-center">
            <div>
              <h2 className="font-bold text-3xl md:text-4xl">Our Mission</h2>
              {/* <ul className='py-5 text-xl font-medium'> */}
              {/* <li className='flex items-center gap-2'><TbTransfer className='text-blue-600' /> Physical card in Standard and Premium options</li>
                                        <li className='flex items-center gap-2'><PiGlobeHemisphereWestLight className='text-blue-600' /> Instantly issued Virtual card</li>
                                        <li className='flex items-center gap-2'><MdOutlinePermContactCalendar className='text-blue-600' /> Make purchases or withdraw cash from ATMs</li> */}
              <p className="py-2   text-lg font-medium text-gray-600">
                At FinMaster, our mission is to empower individuals with
                financial knowledge and provide them with the right tools to
                make informed decisions about their money. We believe that
                financial literacy is the foundation of financial freedom, and
                we are committed to simplifying complex financial concepts for
                everyone—whether you're a first-time investor, a credit card
                seeker, or someone looking for the best insurance plans.
              </p>
              <p className="mt-0.5 text-lg font-medium text-gray-600">
                Through unbiased comparisons, expert insights, and smart
                financial tools, we aim to bridge the gap between consumers and
                the best financial products available. Our goal is to ensure
                that everyone, regardless of their financial background, can
                access trustworthy advice and personalized recommendations to
                achieve their financial aspirations.
              </p>
              <p className="mt-0.5 text-lg font-medium text-gray-600">
                At FinMaster, we are not just a platform—we are your financial
                partner, guiding you at every step toward a more secure and
                confident financial future. Make smart moves with FinMaster.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center mt-10 md:mt-0 mb-4">
        <div className="w-[90%] flex flex-wrap md:flex-nowrap justify-between ">
          <div className="w-full md:hidden">
            <img src="../assets/vision121.png" alt="img1" />
          </div>

          <div className="md:w-full flex items-center">
            <div>
              <h2 className="font-bold text-3xl md:text-4xl">Our Vision</h2>
              {/* <ul className='py-5  text-xl font-medium'> */}
              {/* <li className='flex items-center gap-2'><TbTransfer className='text-blue-600' /> Physical card in Standard and Premium options</li>
                                        <li className='flex items-center gap-2'><PiGlobeHemisphereWestLight className='text-blue-600' /> Instantly issued Virtual card</li>
                                        <li className='flex items-center gap-2'><MdOutlinePermContactCalendar className='text-blue-600' /> Make purchases or withdraw cash from ATMs</li> */}
              <p className="py-2  text-lg font-medium text-gray-600">
              We envision a future where navigating personal finance is seamless, transparent, and hassle-free. By leveraging technology, expert insights, and user-friendly tools, we aim to bridge the gap between financial products and consumers, ensuring they find the best solutions tailored to their needs.
              </p>
              <p className=" mt-0.5 text-lg font-medium text-gray-600">
                We envision a future where navigating personal finance is
                seamless, transparent, and hassle-free. By leveraging
                technology, expert insights, and user-friendly tools, we aim to
                bridge the gap between financial products and consumers,
                ensuring they find the best solutions tailored to their needs.
              </p>

              <p className=" mt-0.5 text-lg font-medium text-gray-600">
              Our commitment is to educate, simplify, and innovate, making finance understandable for all—whether you're choosing an insurance plan, comparing credit cards, or planning your investments.
              </p>
              <p className=" mt-0.5 text-lg font-medium text-gray-600">
              With FinMaster, financial empowerment isn't just a goal—it’s a reality. 🚀 Your journey to financial success starts here!
              </p>

              {/* </ul> */}
              {/* <ul className='py-5 text-xl font-medium'>
                                        <li className='text-base'>
                                            <span className='text-lg font-semibold text-blue-600'>Credit Cards:</span> Discover a world of possibilities with our detailed credit card comparisons. From cashback offers to travel rewards, we break down the features, fees, and benefits, helping you find the card that aligns perfectly with your lifestyle and spending habits.
                                        </li>
                                        <li className='py-2 text-base'>
                                            <span className='text-lg font-semibold text-blue-600'>Insurance:</span> Protecting what matters most is crucial. Explore our extensive range of insurance comparisons, including life, health, auto, and home insurance. Make informed decisions based on coverage, premiums, and policy terms.
                                        </li>
                                        <li className='text-base'>
                                            <span className='text-lg font-semibold text-blue-600'>Loans:</span> Whether it's a personal loan, home loan, or car loan, we simplify the loan comparison process. Find the best interest rates, repayment terms, and loan amounts to suit your financial needs.
                                        </li>
                                        <li className='py-2 text-base'>
                                            <span className='text-lg font-semibold text-blue-600'>Demat Accounts:</span> For savvy investors, our demat account comparisons are designed to help you choose the right platform for your stock trading and investment needs. Compare brokerage charges, user interface, and additional features effortlessly.
                                        </li>
                                    </ul> */}
            </div>
          </div>
          <div className="md:w-full hidden md:block mt-12">
            <img src="../assets/vision121.png" alt="img1" />
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-12 text-gray-700">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-black">
        Our Values
      </h2>
      <p className="text-lg text-center mb-12">
        At FinMaster, we uphold principles that empower financial confidence, transparency, and innovation, 
        ensuring individuals make informed financial decisions.
      </p>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Empowerment Through Knowledge */}
        <div className="flex items-start gap-4">
          <span className="text-3xl">📚</span>
          <div>
            <h3 className="text-xl font-semibold mb-2">Empowerment Through Knowledge</h3>
            <p className="text-gray-600">
              We believe financial literacy is the foundation of success. Our goal is to provide clear, 
              unbiased, and insightful information to help individuals make informed financial decisions.
            </p>
          </div>
        </div>

        {/* Transparency & Trust */}
        <div className="flex items-start gap-4">
          <span className="text-3xl">🔍</span>
          <div>
            <h3 className="text-xl font-semibold mb-2">Transparency & Trust</h3>
            <p className="text-gray-600">
              Integrity is at the heart of everything we do. We prioritize transparency, ensuring that our 
              users receive honest, accurate, and up-to-date financial insights without hidden agendas.
            </p>
          </div>
        </div>

        {/* Innovation & Simplicity */}
        <div className="flex items-start gap-4">
          <span className="text-3xl">🚀</span>
          <div>
            <h3 className="text-xl font-semibold mb-2">Innovation & Simplicity</h3>
            <p className="text-gray-600">
              Finance doesn’t have to be complicated. We leverage technology to simplify financial concepts, 
              making it easier for users to compare, choose, and manage financial products with confidence.
            </p>
          </div>
        </div>

        {/* User-Centric Approach */}
        <div className="flex items-start gap-4">
          <span className="text-3xl">🤝</span>
          <div>
            <h3 className="text-xl font-semibold mb-2">User-Centric Approach</h3>
            <p className="text-gray-600">
              Our users come first. Every tool, article, and resource we create is designed to address 
              real financial challenges, ensuring accessibility and ease of use for everyone.
            </p>
          </div>
        </div>
      </div>
    </div>
      {/* <div className="container mx-auto py-20">
        <p className="text-center text-lg leading-8">
          On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          {data.map((d, index) => (
            <div key={"listprice" + index} className="flex flex-col items-center gap-4">
              <div className="w-34 h-24 rounded-full flex items-center justify-center">
                <img src={d.iconbutton} alt="Icon" className="w-20 h-20" />
              </div>
              <div className="flex flex-col items-center gap-3">
                <p className="text-4xl tracking-tighter">{d.price}</p>
                <p className="text-lg leading-normal text-blue-gray-600">{d.ownedfrom}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      {/* <div class="px-4 sm:px-8 lg:px-10 mb-8">
    <div class="w-full py-8 text-white bg-blue-600 rounded-lg shadow-lg">
        <div class="max-w-[1240px] mx-auto flex flex-col lg:flex-row items-center lg:justify-between">
            <div class="flex flex-col lg:flex-row items-center mb-4 lg:mb-0 lg:mr-4">
                <img src="../assets/newsletter.jpeg" alt="icon" class="w-48 h-40 mb-4 lg:mb-0 lg:mr-4" />
                <div class="text-center lg:text-left max-w-full lg:max-w-[60%]">
                    <h1 class="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 whitespace-normal lg:whitespace-nowrap">
                        Never miss out on exclusive offers and updates!
                    </h1>
                    <p class="text-lg sm:text-xl">Sign up now to receive personalized deals and stay in the loop.</p>
                </div>
            </div>
            <div class="flex flex-col sm:flex-row items-center w-full lg:w-auto mt-4 lg:mt-20 lg:mr-4">
                <input
                    class="flex-grow lg:flex-grow-0 rounded-md text-black p-2 mb-4 sm:mb-0 sm:mr-4"
                    type="email"
                    placeholder="Enter Email"
                />
                <button class="rounded-md font-medium w-auto lg:w-[200px] px-6 py-3 text-white bg-black hover:bg-gray-900">
                    Notify Me
                </button>
            </div>
        </div>
    </div>
</div> */}
      {/* <AboutCrousel/> */}
      <Newsletter />
      {/* <div className="container mx-auto px-4 py-10 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="flex flex-col justify-center gap-10">
            <div>
              <h1 className="text-4xl md:text-4xl font-bold tracking-wide mb-4">
                What We Aim For?
              </h1>
              <p className="text-lg md:text-xl leading-relaxed">
                Our Mission: Simplifying Finance for Everyone
              </p>
            </div>
            <div className="flex flex-col gap-6">
              <div className="flex gap-4 items-start">
                <div className="flex items-center justify-center h-10 w-10 rounded-full border-2 border-gray-900 font-bold text-xl">
                  1
                </div>
                <div className="flex flex-col gap-2">
                  <h5 className="text-lg md:text-xl font-semibold">
                    {" "}
                    Demystifying Financial Complexity:{" "}
                  </h5>
                  <p className="text-xl font-medium leading-relaxed text-gray-600">
                    Financial information can feel like a foreign language. We
                    breaks down complex concepts into clear, easy-to-understand
                    explanations.{" "}
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="flex items-center justify-center h-10 w-10 rounded-full border-2 border-gray-900 font-bold text-xl">
                  3
                </div>
                <div className="flex flex-col gap-2">
                  <h5 className="text-lg md:text-xl font-semibold">
                    {" "}
                    Taking Control of Your Finances:
                  </h5>
                  <p className="text-xl font-medium leading-relaxed text-gray-600">
                    Knowledge is power, especially when it comes to your money.
                    TheFinMaster.com equips you with the tools to make right
                    decisions.{" "}
                  </p>{" "}
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="flex items-center justify-center h-10 w-10 rounded-full border-2 border-gray-900 font-bold text-xl">
                  3
                </div>
                <div className="flex flex-col gap-2">
                  <h5 className="text-lg md:text-xl font-semibold">
                    {" "}
                    Transparency is Key:
                  </h5>
                  <p className="text-xl font-mediumleading-relaxed text-gray-600">
                    We believe in clear communication. Our platform offers a
                    transparent view, allowing you to compare and choose with
                    confidence.
                  </p>{" "}
                </div>
              </div>

              
            </div>
          </div>
          <div className="flex justify-center items-center">
            <img
              src="../assets/about11.webp"
              alt="image"
              className="rounded-lg object-cover w-full md:w-auto md:h-auto"
            />
          </div>
        </div>
      </div> */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10">
  <div className="flex justify-center items-center">
    <img src="https://cdn3d.iconscout.com/3d/premium/thumb/about-us-10487023-8529328.png" alt="image" className="rounded-lg object-cover w-full md:w-auto md:h-auto" />
  </div>
  <div className="flex flex-col justify-center gap-10  ">
    <div>
      <h1 className="text-4xl md:text-5xl font-bold tracking-wide mb-4 ml-3  ">Our vision is simple.</h1>
      <p className="text-lg md:text-xl leading-relaxed ml-3">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. In a free hour,
        On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and
        demoralized by the charms of pleasure of the moment.
        <br />
        In a free hour, On the other hand, we denounce with righteous indignation and dislike men .
      </p>
    </div>
  </div>
</div> */}

      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 mt-10">
        <h1 className="text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AboutPage;

// import React from 'react'
// import AccordionComponent from '../accordion/AccordionComponent'

// const AboutPage = () => {
//     return (
//         <div className='w-full flex flex-col items-center'>
//         {/* <div className='w-full h-screen bg-black'> */}
//         <div className='w-full h-screen bg-cover bg-center' style={{ backgroundImage: 'url("/bg1.avif")' }}>
//           <div className='flex flex-col items-center gap-5 p-5 md:p-10'>
//             <h1 className='about text-white text-center pt-10 mb-10 text-4xl md:text-8xl border-b border-blue-600'>About Us</h1>
//             <p className='text-gray-200 text-center w-full md:w-[80%] text-lg md:text-2xl'>
//               We&apos;re your one-stop resource for personal loans, credit cards, and demat accounts. Our experts simplify the world of finance, helping you make informed choices for a brighter financial future. Explore our guides and comparisons to find the best options for your needs. Start your journey to financial success with FinancialEase Hub!
//             </p>
//             <p className='text-gray-200 text-center w-full md:w-[80%] text-lg md:text-2xl'>
//               FinancialEase Hub is your go-to destination for all things finance. We're here to support you on your financial journey, so you can make the best decisions for a brighter financial future. Welcome to the hub of financial possibilities!
//             </p>
//           </div>
//         </div>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default AboutPage
